/* Copyright (c) 2022 chilled.dev */

import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#fb8c00',
    },
    secondary: {
      main: '#ff7043',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
